var _rect, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMobilePayment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.000976562,
    width: 25,
    height: 25,
    fill: "url(#pattern0_23_297)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_23_297",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_23_297",
    transform: "scale(0.0111111)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_23_297",
    width: 90,
    height: 90,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFoAAABaCAYAAAA4qEECAAAACXBIWXMAAAsTAAALEwEAmpwYAAAFEUlEQVR4nO2dz4scRRTH29/KKpHgD/yBP0hicHH6vXYQI0LWQxRP6sGACIp4yEFcNY5x+lUPNIh/gCAI4kFF/IGCBC/egnjwJ5gIHgSFSHJYwq5d1bsbL24cqZmsmM10z2x3VXW/2f7Cg6Xpqv7Md96+7qnurvK8Ro0aNape/Xju8oTwRUn4vRK4qgT2mcSqFPhdKvCF/vzOy7w6a+nV1s1KwM81MK1fLuCY/ixeXTN5OkzG/8yuZWbrcmHhA1M/nr101PH0dkUoNu6/0PFnRmwvFhTMe3XT2Zps1OhT8eyVecdcPLT7qlH7b9xeNCTBt17dpAhXjGc0ocjNaAHRxv212edtLx7LXt2UBTtZW+haKDvrEdvmd6qyoDLyX5YC1kwZrPvSfbridyYToAkFviJ4Xwk8WcT0QRvCE0rAe0mv1XLN70RsQLnzswHlzs8GlDs/G1Du/GxAufOzAeXOzwaUOz8bUO78bEC587MB5c7PBpQ7PxtQ7vy2QRXz/o2JuxGqMXqoxugpMUI1GT1UY7RlI/oH2pekoX9vVv/6rkw/9i4se5wtm9FJFOyVBB8pgtNZfa+HJPxTEb4tBWBd+K3JFOiSgJsUweFx5o40XOA/ivBdFc9ur4rfukyAJr1WS9+YLWLyuYbDb2kPd7nmd6KyoCuxf50Jk/8Xx5cJr3XF70xlQaWux+ZMXi8lH7jid6YyoGkPd0nCMzmlYE0SfqLC4OE09O9QUXuH/ls/vyEJ/s5sR3gm7bV22+Z3qjKgMsRXcrOTgicyjxviPfoZuez2ENnmd6oyoErAZzlGHRvXXhJ2sr8kOGybn5HR+HVORh8Z1z7ptm/R19EZEdrmnw6jCVdk5N9eZ/4pKR2o//3/UIRP9vfvv6iO/HxOhpRTY8/NbqkIP5cEB2UEDyTd9rY68PMxugu35V2m5f3klgS/6+tlJeDA4qHgxir4naosqBTw1maNPt94WJMCvkzF3Xtc8ztTWdATB/dcYeqFo2Gm45t6iNUVvzOZAD01fNEn/8S4uQz/uO95F7jidyKToGrw8xqPDIY9S5qdCHzaNb9V2QBNouBWKfxnB++1EP5S6L0Wwl+r4rciF6ALHX9mmeB+fXmnCL9QBOlEhkftHXXgN6IqQBc6/owU8JIS8Fdu+QiDR+rIX0hVgqZh8NSYk+IzdebflIqCJlGwVxF+OjIEvDHJsZfj9jVj6vTjtvidqyioInwwJxPXVBjsHNdH3uMIOtIwuM8Wv3MVBV2hu67Pu7uiBP60Kto3ZLWXMVwtBfyQ0351knk3pt7oCcaj9ejdaUXwTiLwUdn1A317SkW4TxK8JgkWx9TnD70JtDWMjnBfrtEFQw9ULfeCO23zO1VZUKXvhhg3Gjuu+J2pLGg/nrvY1CMHZweVXnfJ70ymQJXA56SApRJGH5cEj1XFb10mQZNue9tgohSCHyfLYD0GAl/pcRE9W1nV/FZlC1TFs9tVCA9l9Z8Qzo2b5KpKfuOyDaqY929M3I1QjdFDNUZPiRGqyeihGqMdGWFbbPjZgHLnZwPKnZ8NKHd+NqDc+dmAcudnA8qdnw0od342oNz52YBy52cDyp2fDSh3fjag3PnZgHLnZwPKnd/Kgjei4iBIva2whJOqOGq5hJNeB7BqY5TxgOe9ukk/GqunfKjeHDQThEez1umqy8KR/M0mPKpnK/PqrEFmUzCv6xurEyThihTwjS4Xtc3kRo0aeVtM/wLBPIja08/FRgAAAABJRU5ErkJggg=="
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobilePayment);
export default __webpack_public_path__ + "static/media/Mobile Payment.fc03f36348f8a3b3306f4fa68e1094f0.svg";
export { ForwardRef as ReactComponent };